var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DsfFormControlBox", {
    staticClass: "ds-system",
    attrs: { owner: _vm._self },
    scopedSlots: _vm._u([
      {
        key: "simple",
        fn: function () {
          return [_vm._v(_vm._s(_vm.setVal))]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [_vm._v(_vm._s(_vm.setVal))]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }